const initialState = {
  id: null,
  name: "",
  shortName: "",
};

// Client Company Information Reducer
const clientReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CLIENT":
      return {
        ...state,
        ...action.payload,
      };
    case "CLEAR_CLIENT":
      return {
        ...state,
        id: null,
        name: "",
        shortName: "",
      };
    default:
      return state;
  }
};

export default clientReducer;
